/**
 * @generated SignedSource<<96032ff9f68118cac49216afb229569e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GameFeedViewerQuery$variables = {};
export type GameFeedViewerQuery$data = {
  readonly viewer: {
    readonly hasBeenGoalie: boolean;
  } | null;
};
export type GameFeedViewerQuery = {
  variables: GameFeedViewerQuery$variables;
  response: GameFeedViewerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBeenGoalie",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GameFeedViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GameFeedViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "340294fec1909ca089aa4f7b57a70d48",
    "id": null,
    "metadata": {},
    "name": "GameFeedViewerQuery",
    "operationKind": "query",
    "text": "query GameFeedViewerQuery {\n  viewer {\n    hasBeenGoalie\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3143d91c1af567f49342c3b8aa86a50e";

export default node;
